
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: "AIzaSyBSple_N-PDUnpWtfwGdiVOY_KnpTElG0c",
  authDomain: "portfolio-akshats911.firebaseapp.com",
  projectId: "portfolio-akshats911",
  storageBucket: "portfolio-akshats911.appspot.com",
  messagingSenderId: "865780073572",
  appId: "1:865780073572:web:4bbbc7944c8d95784f8b71"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth();
const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);


export const signInWithGoogle = () => signInWithPopup(auth, provider);